import * as Immutable from 'immutable';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { creationClipSuggestionsSchema } from 'redux/middleware/api/creation-service/schemas';
import {
  CreationClipSuggestion,
  CreationClipSuggestions,
} from 'redux/middleware/api/creation-service/types';
import { State } from 'redux/types';
import { DeepImmutableMap } from 'types';
import { entitiesSelector } from './base';

// selects the entire suggestion group
const creationSuggestionGroupSelector = state =>
  entitiesSelector(state).getIn(['creationClipSuggestions', 'clipGroup']);

// selects the map of suggestions keyed by their ids
const creationSuggestionsByIdSelector = state =>
  entitiesSelector(state).get('creationClipSuggestion');

// selects the denormalized version of the creationSuggestionGroupSelector
export const creationClipSuggestionsSelector = createSelector(
  creationSuggestionGroupSelector,
  creationSuggestionsByIdSelector,
  (
    creationClipSuggestions,
    creationClipSuggestion,
  ): DeepImmutableMap<CreationClipSuggestions> => {
    const entities = Immutable.Map({ creationClipSuggestion });
    return denormalize(
      creationClipSuggestions,
      creationClipSuggestionsSchema,
      entities,
    );
  },
);

export const creationSuggestionSelector = (
  id: number,
  state: State,
): CreationClipSuggestion => {
  const suggestions = creationSuggestionsByIdSelector(state);
  return suggestions.get(String(id))?.toJS();
};

export const creationClipSuggestionsListSelector = createSelector(
  creationClipSuggestionsSelector,
  creationClipSuggestions =>
    !creationClipSuggestions
      ? []
      : (creationClipSuggestions
          ?.get('suggestions')
          .filter(suggestion => suggestion.get('status') !== 'failed')
          ?.toJS() as CreationClipSuggestion[]),
);

export const pollCreationClipSuggestionsIdsSelector = createSelector(
  creationClipSuggestionsListSelector,
  creationClipSuggestions => {
    if (!creationClipSuggestions.length) {
      return undefined;
    }

    return creationClipSuggestions
      .filter(({ status }) => status !== 'completed')
      .map(({ suggestionId }) => suggestionId);
  },
);

export const creationEddyProjectIdSelector = createSelector(
  creationClipSuggestionsSelector,
  suggestions => suggestions?.get('eddyProjectCuid'),
);
